import { Form } from '@thoughtspot/radiant-react/widgets/form-builder/form';
import { FormSeperator } from '@thoughtspot/radiant-react/widgets/form-builder/form-seperator';
import { InputFactory } from '@thoughtspot/radiant-react/widgets/form-builder/input-factory';
import { isValidField } from '@thoughtspot/radiant-react/widgets/form-builder/utils';
import React, { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
export const FormComponent = ({ formFields, viewMode = 'edit', itemLayout = 'vertical', isEdited, onFormElementValueChange, }, ref) => {
    const [formState, setFormState] = useState(formFields);
    useEffect(() => {
        setFormState(formFields);
    }, [formFields]);
    const handleOnSubmit = () => {
        const updateState = formState.map(formField => {
            const tempFormField = Object.assign(formField);
            const value = formField.value;
            const isValid = isValidField(formField.id, value, formField.validation);
            tempFormField.valid = isValid;
            return tempFormField;
        });
        setFormState(updateState);
        return updateState;
    };
    useImperativeHandle(ref, () => ({
        onSubmitForm: () => {
            return formState;
        },
        onCancelForm: () => {
            return formState;
        },
        validateAndSubmitForm: () => {
            return handleOnSubmit();
        },
    }));
    const onValueChanged = (id, value) => {
        const updateState = formState.map(formField => {
            const tempFormField = Object.assign(formField);
            if (id === formField.id) {
                const isValid = isValidField(id, value, formField.validation);
                tempFormField.valid = isValid;
                tempFormField.value = value;
            }
            return tempFormField;
        });
        if (isEdited) {
            isEdited(true, id);
        }
        onFormElementValueChange(id, value);
        setFormState(updateState);
    };
    return (React.createElement(Form, { "data-radiant-v2": true }, formFields.map((formItem) => {
        return (React.createElement("div", { key: formItem.id },
            React.createElement(InputFactory, { rowLayout: itemLayout, mode: viewMode, ...formItem, onValueChanged: onValueChanged }),
            viewMode === 'view' ? React.createElement(FormSeperator, null) : null));
    })));
};
const FormBuilder = forwardRef(FormComponent);
export { FormBuilder };
//# sourceMappingURL=form-builder.js.map